(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateEditorPdfToolbar', drvDocumentTemplateEditorPdfToolbar);

    drvDocumentTemplateEditorPdfToolbar.$inject = ['DocumentTemplate'];
    
    /**
     * @ngdoc Directive
     * @name drvDocumentTemplateEditorPdfToolbar
     *
     * @description
     * Toolbar for interacting with PDF editor (drv-pdf-render)
     *
     * # Scope Params
     * {Object} pdfRenderApi - A PDF render API from drv-pdf-render
     * {Array} selectedPdfElements
     * {Number} scale - PDF rendering scale/zoom
     * {String} interactionMode
     * {DocumentTemplate} documentTemplate
     * {TestMerge} testMerge
     */
    function drvDocumentTemplateEditorPdfToolbar(DocumentTemplate) {
        var directive = {
            restrict: 'E',
            controller: DocumentTemplateEditorPdfToolbarCtrl,
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                pdfRenderApi: '=',
                selectedPdfElements: '=',
                scale: '=',
                interactionMode: '<?',
                documentTemplate: '<?',
                testMerge: '<?'
            },
            templateUrl: 'app/DocumentTemplate/PDF/document-template-editor-pdf-toolbar.tmpl.html'
        };

        DocumentTemplateEditorPdfToolbarCtrl.$inject = ['pdfedit_zoomPresets'];

        return directive;

        function DocumentTemplateEditorPdfToolbarCtrl(pdfedit_zoomPresets) {
            var vm = this;
            vm.zoomPresets = pdfedit_zoomPresets;
        }
    }
})();